import React, { Component } from 'react';
import { translate } from 'react-i18next';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import Tag from '../../components/Tag';


class CardHistory extends Component {
    render() {
        const rooms = this.props.rooms;
        const { t } = this.props;
        const memberId = this.props.usert ? true : false

        return (
            <div className="list-card-resvations" >
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="grid-2">
                            {rooms.map((room) =>
                            (
                                <div className="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-6 card-panel-rooms" key={room.id}>
                                    <Link to={"/history/" + room.id} className="card-link">
                                    <div className="card-panel panel-default card card-link">
                                        <div className="panel-heading" style={{ backgroundImage: "url('" + room.picture + "')" }}>
                                        </div>
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{room.name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="panel-description-text">
                                                {room.title ? (
                                                    <span>
                                                        {room.title.slice(0, 150)}{room.title.length > 150 ? '...' : null}
                                                    </span>
                                                ) : (
                                                    <span>
                                                        Reservación de sala de Sala {room.name.toUpperCase()}
                                                    </span>
                                                )}
                                                </div>

                                                <div className="panel-description-information">
                                                    <div className="flex-tags flex-tags__big">
                                                        <Tag
                                                            isBigTag
                                                            icon='calendar'
                                                            text={t("venta_linea.reservation_tags.date")}
                                                            value={moment(room.start_date, 'YYYY-MM-DD HH:mm:ss').format('ll')}
                                                        />
                                                        <Tag
                                                            isBigTag
                                                            alt
                                                            icon='people-group'
                                                            text={t("venta_linea.reservation_tags.capacity")}
                                                            value={`${room.capacity} personas`}
                                                        />
                                                        <Tag
                                                            isBigTag
                                                            icon='clock'
                                                            text={t("venta_linea.reservation_tags.time")}
                                                            value={`${moment(room.start_date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')} - ${moment(room.end_date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')}`}
                                                        />
                                                        <Tag
                                                            isBigTag
                                                            alt
                                                            icon='user'
                                                            text='Por:'
                                                            value={room.member_name}
                                                        />
                                                    </div>
                                                    <div className="panel-body-bottom content-buttons">
                                                        {room.cancel_button && memberId ? (
                                                            <button
                                                                className="btn btn-default btn-danger-inverse btn-full-width"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                    this.props.cancelarReservation(room)}
                                                                } 
                                                                type="button">
                                                                {t('dashboard.history.cancel_reservation')}
                                                            </button>
                                                        ) : null}
                                                        {room.update && memberId ? (
                                                            <button
                                                                className="btn btn-secondary btn-full-width"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                    this.props.updateReservation(room)}
                                                                } 
                                                                type="button">
                                                                {t('dashboard.history.Extend_reservation')}
                                                            </button>
                                                        ) : null}
                                                        <Link to={"/history/" + room.id} className="btn btn-primary btn-full-width">
                                                                {t('dashboard.history.btn_info')}
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(CardHistory);


// WEBPACK FOOTER //
// ./src/dashboard/history/CardHistory.js